import { WorkspaceStatus } from "../WorkspaceStatus";
import { Currency, PaymentPeriod, WorkspaceTier } from "./Types";

export class Tier {
  //price per month
  public priceJPY: number;
  public priceEURO: number;
  public priceUSD: number;

  constructor(public tier: WorkspaceTier, public name: string, public priceKRW: number, public features: string[]) {
    this.priceJPY = Math.round(priceKRW * 0.11);
    this.priceEURO = Math.round(priceKRW * 0.0007);
    this.priceUSD = Math.round(priceKRW * 0.00079);
  }

  static getPrice(tier: Tier, currency: Currency) {
    switch (currency) {
      case 'krw':
        return `${tier.priceKRW.toLocaleString()} 원`;
      case 'jpy':
        return `${tier.priceJPY.toLocaleString()} 円`;
      case 'eur':
        return `${tier.priceEURO.toLocaleString()} €`;
      default:
        return `$${tier.priceUSD.toLocaleString()} USD`;
    }
  }

  static isTierAtLeast(tier: WorkspaceTier | undefined, minimumTier: WorkspaceTier): boolean {
    return this.getTierNumber(tier) >= this.getTierNumber(minimumTier);
  }

  static getTierNumber(tier: WorkspaceTier | undefined) {
    switch (tier) {
      case 'FREE':
        return 0;
      case 'BASIC':
        return 1;
      case 'STANDARD':
        return 2;
      case 'PREMIUM':
        return 3;
      case 'PREMIUM_TRIAL':
        return 3;
      case 'PREMIUM_PARTNER':
        return 4;
      default:
        return -1;
    }
  }

  static hasTrialExpired(wsStatus: WorkspaceStatus | undefined) {
    if (wsStatus?.trialEnd) {
      return wsStatus.tier == 'FREE' && new Date(wsStatus.trialEnd).getTime() < new Date().getTime();
    }
    return false;
  }

  static getStripePriceID(tier: Tier, currency: Currency, period: PaymentPeriod) {
    if (import.meta.env.VITE_STRIPE_MODE === 'test') {
      if (currency === 'krw') {
        if (period === 'monthly') {
          if (tier.tier === 'BASIC')
            return 'price_1NTQNIE2olNho9KH79lDeXli';
          else if (tier.tier === 'STANDARD')
            return 'price_1NTTwAE2olNho9KHkWwy3IoP';
          else if (tier.tier === 'PREMIUM')
            return 'price_1NTTwxE2olNho9KHLRK4g4uF';
        }
      } else if (currency === 'jpy') {
        if (period === 'monthly') {
          if (tier.tier === 'BASIC')
            return 'price_1NTU1WE2olNho9KH6QLcrMer';
          else if (tier.tier === 'STANDARD')
            return 'price_1NTU2SE2olNho9KHqqs0XoCk';
          else if (tier.tier === 'PREMIUM')
            return 'price_1NTU2yE2olNho9KHSlDdD07R';
        }
      } else if (currency === 'usd') {
        if (period === 'monthly') {
          if (tier.tier === 'BASIC')
            return 'price_1NYWXUE2olNho9KHCa2IqAfw';
          else if (tier.tier === 'STANDARD')
            return 'price_1NYWYsE2olNho9KHdouz5dvp';
          else if (tier.tier === 'PREMIUM')
            return 'price_1NYWZvE2olNho9KHHhCGlGne';
        }
      }
      throw new Error("Oops, this product is not supported yet.");
    } else {
      if (currency === 'krw') {
        if (period === 'monthly') {
          if (tier.tier === 'BASIC')
            return 'price_1NafjJE2olNho9KHVlC4ZJGi';
          else if (tier.tier === 'STANDARD')
            return 'price_1Nafm0E2olNho9KHNqWBBv29';
          else if (tier.tier === 'PREMIUM')
            return 'price_1NafnDE2olNho9KHKNmqdbC8';
        }
      } else if (currency === 'jpy') {
        if (period === 'monthly') {
          if (tier.tier === 'BASIC')
            return 'price_1NaaLqE2olNho9KH89qZUctv';
          else if (tier.tier === 'STANDARD')
            return 'price_1NaaLtE2olNho9KHxjx1GhXX';
          else if (tier.tier === 'PREMIUM')
            return 'price_1NaaM6E2olNho9KH8RQ0bY8V';
        }
      } else if (currency === 'usd') {
        if (period === 'monthly') {
          if (tier.tier === 'BASIC')
            return 'price_1NaaMBE2olNho9KHL9kMtvRk';
          else if (tier.tier === 'STANDARD')
            return 'price_1NaaMEE2olNho9KHBHJ7IRUi';
          else if (tier.tier === 'PREMIUM')
            return 'price_1NaaMHE2olNho9KHdo5Wyko8';
        }
      }
      throw new Error("Oops, this product is not supported yet.");

    }
  }

}

